import * as React from 'react';
import styled from 'styled-components';

import { Modal } from '@process-advisor/process-miner/components/modal/modal';
import { useApiListener } from '@process-advisor/process-miner/shared/hooks/useApiListener';
import { Text} from '@process-advisor/process-miner/modals/text';
import { Event } from '@process-advisor/process-miner/api/events';
import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';
import { Dropdown } from '@process-advisor/process-miner/components/shared/dropdown';
import { Section } from '@process-advisor/process-miner/modals/section';
import { getShadow } from '@process-advisor/process-miner/shared/theme';
import { Typography } from '@mui/material';
import { type CommentsModalProps } from '@process-advisor/process-miner/api/methods/modals/commentsModal';
import { DataGrid } from '@process-advisor/process-miner/filters/status/dataGrid';
import { SidebarLoaderContext, type SidebarLoaderContextType } from '@process-advisor/process-miner/shared/providers/sidebarLoaderProvider';


const Wrapper = styled.div`
    box-shadow: ${getShadow('pane')};
`;

const Wrapper1 = styled.div`
    display: grid;
    align-items: baseline;
    grid-template-columns: 150px 610px;
    grid-gap: 10px;
    padding: 10px 20px 15px 15px;
`;

const variantTypes = [
    { value: 'all_variants', label: 'All variants' },
    { value: 'selected_variants', label: 'Selected variants' },
];


const filtersGridColumns = () => [
    {
        field: 'type',
        headerName: 'Type',
        width: 150
    },
    {
        field: 'description',
        headerName: 'Description',
        width: 450
    },
];
export type Row = {};


export const CommentsModal = () => {
    const [data, setData] = React.useState<{type:string, component:string, activity: string, fromNode: string, toNode: string, variantType: string, filterSummary: any,  comment: string, createdBy: string}
    >({ type: '', component: '',  activity: '', fromNode: '', toNode: '', variantType: '', filterSummary: '', comment: '', createdBy: ''  });
    
    const [isOpen, setIsOpen] = React.useState(false);
    const [variantType, setvariantType] = React.useState<string>('all_variants');
    const [filterConditions, setFilterConditions] = React.useState<string>('all');
    const [type, setType] = React.useState<string>('');
    const [component, setcomponent] = React.useState<string>('');
    const [comment, setComment] = React.useState<string>('');
    const [createdBy, setCreatedBy] = React.useState<string>('');
    const [name, setName] = React.useState('');
    const [source, setSource] = React.useState('');
    const [mode, setMode] = React.useState('');
    const [applyEnabled,setApplyEnabled,] = React.useState<boolean>(false);
    const [deleteDisabled,setDeleteDisabled,] = React.useState<boolean>(false);
    const [rows, setRows] = React.useState<Row[]>([]);
    const [gridData, setGridData] = React.useState();

    const { setProps } = React.useContext<SidebarLoaderContextType>(SidebarLoaderContext);

    const onCommentChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setComment(event.target.value);
    };

    const onCreatedByChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setCreatedBy(event.target.value);
    };

    const onVariantTypeChange = (type: string) => {
        setvariantType(type);
    };

    useApiListener(
        Event.openCommentsModal,
        ({ data }: CommentsModalProps) => {
            setIsOpen(true);
            setName(name);
            setData(data);
            setComment(data.comment);
            setCreatedBy(data.createdBy)
            setvariantType(data.variantType);
            setType(data.type)
            setcomponent(data.component)
            setMode(data.mode)
            setSource(data.source)
            console.log(data)
            if (data.filterSummary !== undefined ) setRows(data.filterSummary.map((row, id) => ({ id, ...row })))

        }
    );

    React.useEffect(() => {
        setGridData(rows)
    }, [rows]);

    const onOk = () => {
        setProps({
            functionToLoad: () => apiProvider.updateComments({
                activity: data.activity,
                fromNode: data.fromNode,
                toNode: data.toNode,
                component: data.component,
                comment,
                createdBy,
                variantType,
                mode: mode,
                type: 'step',
                source
            }),
        });
    };

    return (
        <Modal title='Comments' open={isOpen} onClose={() => setIsOpen(false)} onOk={onOk}>
            <Wrapper>
                <Wrapper1>
                    <Section title='Process Component' />
                    <Typography
                        variant="caption"
                        align="left"
                        sx={{ fontSize: '14px', fontFamily: 'system-ui'
}}
                        component="div">
                        {component}
                    </Typography>
                    <Section title='Comment' />
                    <Text width='500px' multiline rows={3} maxRows={5} value={comment} onChange={onCommentChange} />
                    <Section title='Variants'/>
                    <Dropdown label='' value={variantType} onChange={onVariantTypeChange} options={variantTypes} />
                    <Section title='Conditions'/>
                    <DataGrid
                        rows={gridData}
                        columns={filtersGridColumns()}
                        setDeleteDisabled={setDeleteDisabled}
                        setApplyEnabled={setApplyEnabled}
                        height="200px" />

                    <Section title='Created By' />
                    <Text width='200px' height='35px' value={createdBy} onChange={onCreatedByChange} />

                </Wrapper1>
            </Wrapper>
        </Modal>
    );
};


